import { DateDailyField } from './DateDailyField'
import { withDateDailyField } from './withDateDailyField'

const connectedDateDailyField = withDateDailyField(DateDailyField)

export { connectedDateDailyField as DateDailyField }
